// extracted by mini-css-extract-plugin
export default {"modalOverlay":"GK-z","modalContent":"HK-z","header":"IK-z","close":"JK-z"};